import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ad1d43a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Sample 1", -1))
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "+", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "=", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Sample 2", -1))
const _hoisted_7 = { class: "row second" }
const _hoisted_8 = ["id", "value"]
const _hoisted_9 = { key: 0 }

import {ref} from 'vue';

interface Meal {
  value: string,
  taste: number
}

// interface Meals extends Array<Meal>

interface ReactiveMeals {
  value: Meal[]
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const num1 = ref(0);
const num2 = ref(0);
const meals: ReactiveMeals = ref([ // typing?!??????
  {
    value: "Burger and fries",
    taste: 1
  },
  {
    value: "Salad with Chicken",
    taste: 2
  },
  {
    value: "Pasta with Tomato Sauce",
    taste: 5
  },
  {
    value: "Tacos",
    taste: 8
  },
]);
const selectedMeal = ref('');


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((num1).value = $event)),
        type: "number"
      }, null, 512), [
        [
          _vModelText,
          num1.value,
          void 0,
          { number: true }
        ]
      ]),
      _hoisted_3,
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((num2).value = $event)),
        type: "number"
      }, null, 512), [
        [
          _vModelText,
          num2.value,
          void 0,
          { number: true }
        ]
      ]),
      _hoisted_4,
      _createElementVNode("span", null, _toDisplayString(num1.value + num2.value), 1)
    ]),
    _hoisted_5,
    _hoisted_6,
    _createElementVNode("div", _hoisted_7, [
      _withDirectives(_createElementVNode("select", {
        name: "meals",
        id: "meals",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedMeal).value = $event))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(meals.value, (meal) => {
          return (_openBlock(), _createElementBlock("option", {
            id: meal,
            value: meal.value,
            key: meal.value
          }, _toDisplayString(meal.value), 9, _hoisted_8))
        }), 128))
      ], 512), [
        [_vModelSelect, selectedMeal.value]
      ]),
      (selectedMeal.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_9, "My favorite meal is " + _toDisplayString(selectedMeal.value), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("pre", null, _toDisplayString(), 1)
  ], 64))
}
}

})